// Model registry. The kickoff names "OpenAI Privacy Filter v1 (~770 MB)" but
// no such public model exists, so we default to a real, well-tested NER
// model. Swap this single line to upgrade the model later — interfaces
// downstream consume only PiiType labels.
export const NER_MODEL_ID = 'Xenova/bert-base-NER';
export const NER_QUANTIZATION = 'q8'; // q8 / fp16 / fp32 supported by Xenova builds
/** Conservative size estimate for the modal copy; q8 BERT-base is ~110 MB. */
export const NER_APPROX_MB = 110;

export type ModelPrefs = {
  /** "enabled" — user opted in; "skipped" — user said no thanks; "ask" — never asked. */
  ner: 'enabled' | 'skipped' | 'ask';
};

const PREFS_KEY = 'anomia:model-prefs';

const DEFAULT_PREFS: ModelPrefs = { ner: 'ask' };

export const readPrefs = (): ModelPrefs => {
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    if (!raw) return DEFAULT_PREFS;
    const parsed = JSON.parse(raw) as Partial<ModelPrefs>;
    if (parsed.ner === 'enabled' || parsed.ner === 'skipped' || parsed.ner === 'ask') {
      return { ner: parsed.ner };
    }
  } catch {
    /* ignore */
  }
  return DEFAULT_PREFS;
};

export const writePrefs = (prefs: ModelPrefs): void => {
  try {
    localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  } catch {
    /* localStorage may be unavailable; we lose the pref but won't crash */
  }
};

export type ProgressEvent =
  | { kind: 'download'; file: string; loaded: number; total: number }
  | { kind: 'ready' }
  | { kind: 'inferring' }
  | { kind: 'done'; ms: number }
  | { kind: 'error'; message: string };

/**
 * Pretty-print a download fraction for the modal.
 */
export const formatProgress = (loaded: number, total: number): string => {
  if (!total || total <= 0) return `${(loaded / 1024 / 1024).toFixed(1)} MB`;
  const pct = Math.min(100, Math.round((loaded / total) * 100));
  return `${(loaded / 1024 / 1024).toFixed(1)} / ${(total / 1024 / 1024).toFixed(1)} MB · ${String(pct)}%`;
};
